.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
}

.scroller {
  overflow-y: scroll;
  padding-top: 2.4rem;
}

.crumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
}

.parent {
  color: #e3e4e7;

  &:hover {
    color: white;
  }
}
